import { Provider } from 'react-redux';
import { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';

// Global app css styles
import '../../styles.scss';
import CustomApp from '@/components/CustomApp';
import { initializeStore } from '@/redux/initialize-store';
import { useEffect, useRef } from 'react';
import { makeMediaQuery } from '@/hooks/useMediaQuery';
import { ScreenSizeProvider } from '@/components/ScreenSize.context';
import { montserrat } from '@/constants/styles';

export const MillesimaApp = (initialProps: AppProps) => {
  const store = useRef(initializeStore({ preloadedState: initialProps.pageProps.initialReduxState })).current;
  const mediaQueryFunc = makeMediaQuery();

  useEffect(() => {
    store.dispatch({
      type: 'HYDRATE',
      payload: initialProps.pageProps.initialReduxState,
    });
  }, [initialProps.pageProps.initialReduxState]);

  return (
    <ScreenSizeProvider mediaQueryFunc={mediaQueryFunc} isMobileDevice={store.getState()?.gui?.isMobileDevice}>
      <Provider store={store}>
        <main className={montserrat.className}>
          <CustomApp {...initialProps} />
        </main>
      </Provider>
    </ScreenSizeProvider>
  );
};

export default appWithTranslation(MillesimaApp);
